// @react
import React, { ReactElement, useEffect, useRef, useState } from 'react'
// @types
import { PropsType as CardProps } from '../../index'
// @components
import Truncate from 'react-truncate'
import TextLink from '@bit/atd.web.text-link'

type PropsType = {
  title: CardProps['content']['title']
  titleURL?: CardProps['content']['titleUrl']
  variant?: 'primary' | 'secondary'
  truncateLines?: number
  target?: string
}

const Title = ({
  title,
  titleURL,
  truncateLines,
  variant,
  target,
}: PropsType): ReactElement => {
  const [width, setWidth] = useState(0)

  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    setWidth(ref?.current?.offsetWidth || 0)
  }, [ref?.current?.offsetWidth])

  return (
    <div ref={ref}>
      {/* If Link */}
      {titleURL && (
        <TextLink href={titleURL} variant={variant} target={target}>
          {truncateLines !== 0 && truncateLines ? (
            <Truncate
              key={width}
              lines={truncateLines}
              ellipsis={'...'}
              width={width}
            >
              {title}
            </Truncate>
          ) : (
            title
          )}
        </TextLink>
      )}

      {/* If Text */}
      {!titleURL &&
        (truncateLines !== 0 && truncateLines ? (
          <Truncate
            key={width}
            lines={truncateLines}
            ellipsis={'...'}
            width={width}
          >
            {title}
          </Truncate>
        ) : (
          title
        ))}
    </div>
  )
}

Title.defaultProps = {
  titleLinkVariant: 'primary',
  truncateLines: 0,
}

export default Title
